module.exports = __webpack_public_path__ + "static/media/impact-analysis.b391c468.svg";